module.exports = __webpack_public_path__ + "img/sv107.3398b9a2.svg";